module.exports = __webpack_public_path__ + "assets/home_pin_orange.aefcb9e6.svg";